import { e as escape_html, c as attr_class, l as bind_props, p as pop, a as push, k as ensure_array_like, h as head, b as attr, m as stringify } from "../../../../chunks/index2.js";
import "@sveltejs/kit/internal";
import "../../../../chunks/exports.js";
import "../../../../chunks/utils.js";
import "../../../../chunks/state.svelte.js";
function OrderCard($$payload, $$props) {
  push();
  let order = $$props["order"];
  function formatDate(date) {
    return new Date(date).toLocaleDateString("en-KE", { year: "numeric", month: "long", day: "numeric" });
  }
  function getOrderStatusColor(status) {
    switch (status) {
      case "COMPLETED":
        return "bg-green-50 text-green-700 border-green-200";
      case "PENDING":
        return "bg-yellow-50 text-yellow-700 border-yellow-200";
      case "CANCELLED":
        return "bg-red-50 text-red-700 border-red-200";
      default:
        return "bg-gray-50 text-gray-700 border-gray-200";
    }
  }
  $$payload.out.push(`<div class="rounded-lg border border-gray-200 bg-white shadow-sm transition-all hover:shadow-md"><div class="p-6"><div class="flex flex-wrap items-center justify-between gap-4"><div class="space-y-1"><div class="flex items-center gap-3"><span class="text-lg font-semibold">Order #${escape_html(order.id)}</span> <span${attr_class(`rounded-full border px-3 py-1 text-sm ${getOrderStatusColor(order.status)}`)}>${escape_html(order.status)}</span></div> <p class="text-sm text-gray-600">${escape_html(formatDate(order.createdAt))}</p> `);
  if (order.ProductOnOrder.some((item) => !item.isIssued)) {
    $$payload.out.push("<!--[-->");
    $$payload.out.push(`<p class="text-xs text-gray-600">Order is being consolidated for dispatch</p>`);
  } else {
    $$payload.out.push("<!--[!-->");
  }
  $$payload.out.push(`<!--]--></div> <div class="text-right"><p class="text-primary text-xl font-bold">KES ${escape_html(order.totalPrice.toLocaleString())}</p> <p class="text-sm text-gray-600">${escape_html(order.ProductOnOrder.length)} item${escape_html(order.ProductOnOrder.length !== 1 ? "s" : "")}</p></div></div> <div class="mt-4 flex items-center justify-between"><button class="hover:text-primary flex cursor-pointer items-center gap-2 rounded-sm bg-gray-200 p-2 text-sm">${escape_html("View")} Products</button></div></div> `);
  {
    $$payload.out.push("<!--[!-->");
  }
  $$payload.out.push(`<!--]--></div>`);
  bind_props($$props, { order });
  pop();
}
function _page($$payload, $$props) {
  push();
  const { data } = $$props;
  const orders = data.orders || [];
  const currentPage = data.page || 1;
  const totalPages = data.totalPages || 1;
  const each_array = ensure_array_like(orders);
  head($$payload, ($$payload2) => {
    $$payload2.title = `<title>My Purchases | Kenya Law</title>`;
  });
  $$payload.out.push(`<div class="container mx-auto px-4 py-8"><div class="mb-8 space-y-2"><h1 class="text-3xl font-bold">My Purchases</h1> <p class="text-gray-600">Track and manage your orders</p></div> <div class="space-y-4">`);
  if (orders.length === 0) {
    $$payload.out.push("<!--[-->");
    $$payload.out.push(`<div class="rounded-lg border border-gray-200 bg-white p-8 text-center"><h3 class="text-lg font-medium">No purchases yet</h3> <p class="mt-2 text-gray-600">When you make a purchase, it will appear here.</p> <a href="/products" class="bg-primary hover:bg-primary/90 mt-4 inline-block rounded-md px-4 py-2 text-sm text-white">Browse Products</a></div>`);
  } else {
    $$payload.out.push("<!--[!-->");
  }
  $$payload.out.push(`<!--]--> <!--[-->`);
  for (let $$index = 0, $$length = each_array.length; $$index < $$length; $$index++) {
    let order = each_array[$$index];
    OrderCard($$payload, { order });
  }
  $$payload.out.push(`<!--]--> `);
  if (totalPages > 1) {
    $$payload.out.push("<!--[-->");
    const each_array_1 = ensure_array_like(Array(totalPages));
    $$payload.out.push(`<div class="mt-8 flex justify-center gap-2"><button class="rounded-md bg-gray-100 px-4 py-2 text-sm disabled:opacity-50"${attr("disabled", currentPage === 1, true)}>Previous</button> <!--[-->`);
    for (let i = 0, $$length = each_array_1.length; i < $$length; i++) {
      each_array_1[i];
      $$payload.out.push(`<button${attr_class(`rounded-md px-4 py-2 text-sm ${stringify(currentPage === i + 1 ? "bg-primary text-white" : "bg-gray-100")}`)}>${escape_html(i + 1)}</button>`);
    }
    $$payload.out.push(`<!--]--> <button class="rounded-md bg-gray-100 px-4 py-2 text-sm disabled:opacity-50"${attr("disabled", currentPage === totalPages, true)}>Next</button></div>`);
  } else {
    $$payload.out.push("<!--[!-->");
  }
  $$payload.out.push(`<!--]--></div></div>`);
  pop();
}
export {
  _page as default
};
